import ChatInterface from "../components/chat/ChatInterface";
import { useOutletContext } from "react-router-dom";

const Home = () => {
  const { isMobile, sidebarOpen, setChats, chats, fetchRecentChats } =
    useOutletContext();
  return (
    <ChatInterface
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setChats={setChats}
      chats={chats}
      fetchRecentChats={fetchRecentChats}
    />
  );
};

export default Home;
